import {apiRoot, TAGS} from "./apiRoot.ts";

export type SurchargeTimeDefinition = {
    id: string,
    name: string,
    endTime: string,
    startTime: string,
    dayOfWeek: string,
}

export type ActivityType = string

export type SurchargeTimeDefinitionCreateDTO = {
    name: string,
    endTime: string,
    startTime: string,
    dayOfWeek: string,
}

export type SurchargeGroup = {
    id: string,
    name: string,
    applicableActivityTypes: Array<ActivityType>,
}

export type SurchargeGroupCreateDTO = {
    name: SurchargeGroup["name"],
    applicableActivityTypes: Array<string>,
}

export const surchargeTimeDefinitionSlice = apiRoot.injectEndpoints({
    endpoints: build => ({
        getSurchargeGroups: build.query<SurchargeGroup[], void>({
            query: () => `/api/worktimeexpense/surchargeGroups`,
            providesTags: [TAGS.SURCHARGE_GROUP]
        }),
        oneSurchargeGroup: build.query<SurchargeGroup, string>({
            query: (id) => `/api/worktimeexpense/surchargeGroups/${id}`,
        }),
        createSurchargeGroup: build.mutation<SurchargeGroup, SurchargeGroupCreateDTO>({
            query: props => ({
                url: "/api/worktimeexpense/surchargeGroups",
                method: "POST",
                body: JSON.stringify(props),
            })
        }),
        updateSurchargeGroup: build.mutation<SurchargeGroup, SurchargeGroup>({
            query: (props) => ({
                url: `/api/worktimeexpense/surchargeGroups/${props.id}`,
                method: "PUT",
                body: JSON.stringify(props),
            })
        }),
        allSurchargeTimeDefinitions: build.query<SurchargeTimeDefinition[], void>({
            query: () => "/api/worktimeexpense/surchargeTimeDefinitions",
            providesTags: [TAGS.SURCHARGE_TIME_DEFINITION]
        }),
        createSurchargeTimeDefinition: build.mutation<SurchargeTimeDefinition, SurchargeTimeDefinitionCreateDTO>({
            query: (props) => ({
                url: "/api/worktimeexpense/surchargeTimeDefinitions",
                method: "POST",
                body: JSON.stringify(props),
            }),
            invalidatesTags: [TAGS.SURCHARGE_TIME_DEFINITION],
        }),
        updateSurchargeTimeDefinition: build.mutation<SurchargeTimeDefinition, SurchargeTimeDefinition>({
            query: (props) => ({
                url: `/api/worktimeexpense/surchargeTimeDefinitions/${props.id}`,
                method: "PUT",
                body: JSON.stringify(props),
            }),
            invalidatesTags: [TAGS.SURCHARGE_TIME_DEFINITION],
        }),
        oneSurchargeTimeDefinition: build.query<SurchargeTimeDefinition, String>({
            query: (id) => `/api/worktimeexpense/surchargeTimeDefinitions/${id}`,
        }),
        deleteSurchargeTimeDefinition: build.mutation<void, String>({
            query: (id) => ({
                method: "DELETE",
                url: `/api/worktimeexpense/surchargeTimeDefinitions/${id}`,
            }),
            invalidatesTags: [TAGS.SURCHARGE_TIME_DEFINITION],

        }),
        getApplicableSurcharges: build.query<any, string>({
            query: (id) => `/api/worktimeexpense/applicableSurcharge/forActivity/${id}`,
        })
    })
})

export const {
    useGetSurchargeGroupsQuery,
    useAllSurchargeTimeDefinitionsQuery,
    useCreateSurchargeTimeDefinitionMutation,
    useUpdateSurchargeTimeDefinitionMutation,
    useLazyOneSurchargeTimeDefinitionQuery,
    useDeleteSurchargeTimeDefinitionMutation,
    useGetApplicableSurchargesQuery,
    useLazyOneSurchargeGroupQuery,
    useCreateSurchargeGroupMutation,
    useUpdateSurchargeGroupMutation
} = surchargeTimeDefinitionSlice